export const DEFAULT_WORKWEEKDAYS = 127; // Bit mask of 2^7
